// extracted by mini-css-extract-plugin
var _1 = "GroupDetailContent-module__animateUploadProgressBarWidth--D4z4C";
var _2 = "GroupDetailContent-module__animatedBackground--RXgeu";
var _3 = "GroupDetailContent-module__banner--KeKCh";
var _4 = "120px";
var _5 = "GroupDetailContent-module__container--chj2q";
var _6 = "GroupDetailContent-module__content--w1qFf";
var _7 = "GroupDetailContent-module__description--PY_B8";
var _8 = "GroupDetailContent-module__hasSeparator--vcttF";
var _9 = "GroupDetailContent-module__headerContainer--ZejfE";
var _a = "GroupDetailContent-module__members--fyZ7b";
var _b = "GroupDetailContent-module__title--I5AQ5";
var _c = "GroupDetailContent-module__titleContainer--XFWEp";
var _d = "GroupDetailContent-module__titleIcon--ckezO";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "banner", _4 as "bannerHeight", _5 as "container", _6 as "content", _7 as "description", _8 as "hasSeparator", _9 as "headerContainer", _a as "members", _b as "title", _c as "titleContainer", _d as "titleIcon" }
